import companyApi from '../../_api'
// import i18n from '@/locales'
export default {
  /* - Mileage Categories  - */
  fetchAlertsSettings: async (
    { commit, dispatch }, officeId
  ) => {
    try {
      let response = []
      response = await companyApi.getAlertsSettings(officeId)
      commit('setAlertsSettings', response.data)
    } catch (error) {
      // dispatch(
      //   'SnackBars/addErrorHandler',
      //   {
      //     error: error,
      //     errorMessage: 'company_fetch_alerts_settings_error'
      //   },
      //   { root: true }
      // )
    }
  },
  updateAlertsSettings: async (
    { commit, dispatch },
    alertsSettings
  ) => {
    try {
      const response = await companyApi.putAlertsSettings(
        alertsSettings.id,
        alertsSettings
      )
      commit('updateAlertsSettings', response.data)
      // dispatch(
      //   'SnackBars/addSuccess',
      //   i18n.t('company_update_alerts_settings_success'),
      //   { root: true }
      // )
    } catch (error) {
      dispatch(
        'SnackBars/addErrorHandler',
        { error: error, errorMessage: 'company_update_alerts_settings_error' },
        { root: true }
      )
    }
  },
  clearStore: ({ commit }) => {
    commit('clearStoreData')
  }
}
